import {useDispatch, useSelector} from "react-redux";
import {API_URL, SOCKET} from "../../../../../../URL";
import {BoardListsAPI} from "../../../../../../store/api/get/Board/Board";
import {useEffect} from "react";

export const ArchiveCards = () => {
    const dispatch = useDispatch();
    const lists = useSelector((state) => state.boards.boardLists || []);

    const archivedCards = lists
        .flatMap((list) =>
            list.cards.map((card) => ({
                ...card,
                board_id: list.board_id,
                listTitle: list.title
            }))
        )
        .filter((card) => card.is_archive === true);

    const handleRestoreCard = async (id, board_id) => {
        const response = await fetch(API_URL + "/post/handle_board_card/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({id})
        });
        dispatch(BoardListsAPI(board_id));
        const data = await response.json();
        SOCKET.emit("handle_board_card", board_id);

    }
    useEffect(() => {
        const handleRenameBoardCard = (boardId) => {
            dispatch(BoardListsAPI(boardId));
        };

        SOCKET.on("handle_board_card", handleRenameBoardCard);

        return () => {
            SOCKET.off("handle_board_card", handleRenameBoardCard);
        };
    }, [dispatch]);
    return (
        <div className="closeBoardModal__body archiveItemsModal__body">
            {archivedCards.length > 0 ? (
                archivedCards.map((card) => (
                    <div className="archiveItemsModal__row" key={card.id}>
                        <div className="archiveItemsModal__info">
                            <span className="archiveItemsModal__title">
                                <span>{card.name}</span> in list: {card.listTitle}
                            </span>

                        </div>

                        <button
                            type="button"
                            className="archiveItemsModal__restore"
                            onClick={() => handleRestoreCard(card.id, card.board_id)}
                        >
                            Restore
                        </button>
                    </div>
                ))
            ) : (
                <p>No archived cards yet.</p>
            )}
        </div>
    );
};